import { instance } from "../apiclient";
class CouponService {

  IsValidated(couponCode, storeId) {
    return instance.get("coupons/" + couponCode + "?CompanyID=" + storeId);
  }
}

export const CouponServiceApi = new CouponService();

